import _ from './underscore-wrapper';
import Cookie from 'vendor/lib/js.cookie';
const SECURED_COOKIE = /^https/.test(window.location.href);
export default {
  setCookie: function (name, value, options) {
    Cookie.set(
      name,
      value,
      _.defaults(options || {}, {
        secure: SECURED_COOKIE,
        path: '/'
      })
    );
  },

  getCookie: function () {
    return Cookie.get.apply(Cookie, arguments);
  },

  removeCookie: function () {
    return Cookie.remove.apply(Cookie, arguments);
  }
};



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/Cookie.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/Cookie.js